// v3.7.0: Extracted from DesktopUI.tsx (3892 lines → now standalone testable component)
import React from 'react';
import { Sparkles, FolderOpen, Calendar, Bell, Bot, Wrench, Music, BarChart3, Camera, Activity, Settings, Glasses } from 'lucide-react';

interface MoreCenterGridProps {
  t: any;
  lang: 'en' | 'zh';
  onOpen: (windowId: string) => void;
}

const VALID_WINDOW_IDS = new Set([
  'skills', 'ecosystem', 'calendar', 'reminders', 'team',
  'tools', 'music-center', 'stats', 'screenshot', 'runtime-log', 'settings', 'glasses-devices',
]);

const ITEMS: { id: string; labelZh: string; labelEn: string; descZh: string; descEn: string; icon: React.ReactNode }[] = [
  { id: 'skills',      labelZh: '技能中心', labelEn: 'Skills',      descZh: '浏览与安装技能', descEn: 'Browse & install skills', icon: <Sparkles size={20} /> },
  { id: 'ecosystem',   labelZh: '项目空间', labelEn: 'Projects',     descZh: '管理项目与对话', descEn: 'Manage projects & chats', icon: <FolderOpen size={20} /> },
  { id: 'calendar',    labelZh: '日历',     labelEn: 'Calendar',     descZh: '日程与事件', descEn: 'Schedule & events', icon: <Calendar size={20} /> },
  { id: 'reminders',   labelZh: '提醒',     labelEn: 'Reminders',    descZh: '待办与提醒事项', descEn: 'Todos & reminders', icon: <Bell size={20} /> },
  { id: 'team',        labelZh: '团队',     labelEn: 'Team',         descZh: '多智能体协作', descEn: 'Multi-agent teams', icon: <Bot size={20} /> },
  { id: 'tools',       labelZh: '工具箱',   labelEn: 'Tools',        descZh: '实用工具集合', descEn: 'Utility tools', icon: <Wrench size={20} /> },
  { id: 'music-center',labelZh: '音乐中心', labelEn: 'Music',        descZh: '音乐创作与播放', descEn: 'Create & play music', icon: <Music size={20} /> },
  { id: 'stats',       labelZh: '用量统计', labelEn: 'Stats',        descZh: 'Token 与用量分析', descEn: 'Usage analytics', icon: <BarChart3 size={20} /> },
  { id: 'screenshot',  labelZh: '截图',     labelEn: 'Screenshot',   descZh: '屏幕截图工具', descEn: 'Screen capture', icon: <Camera size={20} /> },
  { id: 'runtime-log', labelZh: '运行日志', labelEn: 'Runtime Log',  descZh: '查看运行日志', descEn: 'View runtime logs', icon: <Activity size={20} /> },
  { id: 'settings',    labelZh: '设置',     labelEn: 'Settings',     descZh: '系统与个性化', descEn: 'System & preferences', icon: <Settings size={20} /> },
  { id: 'glasses-devices', labelZh: 'AR 眼镜', labelEn: 'AR Glasses', descZh: '小枫 OS 眼镜设备配对管理', descEn: 'Xiaofeng OS glasses device pairing', icon: <Glasses size={20} /> },
];

export function MoreCenterGrid({ t, lang, onOpen }: MoreCenterGridProps) {
  const isZh = lang === 'zh';
  return (
    <div className="mx-auto max-w-5xl p-6">
      <h2 className="mb-4 text-xl font-black text-white">{t?.moreCenter || '全部功能'}</h2>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {ITEMS.map((it) => (
          <button
            key={it.id}
            onClick={() => {
              if (!VALID_WINDOW_IDS.has(it.id)) {
                console.warn('[MoreCenter] unknown windowId:', it.id);
                return;
              }
              onOpen(it.id);
            }}
            className="flex flex-col items-start gap-1.5 rounded-2xl border border-white/10 bg-white/[0.03] p-4 text-left text-white/60 transition-all hover:border-celestial-saturn/40 hover:bg-celestial-saturn/10 focus-visible:ring-2 focus-visible:ring-celestial-saturn/60 focus-visible:outline-none"
            aria-label={isZh ? it.labelZh : it.labelEn}
          >
            <div className="text-celestial-saturn/80">{it.icon}</div>
            <span className="text-sm font-bold text-white/85">{isZh ? it.labelZh : it.labelEn}</span>
            <span className="text-[11px] leading-snug text-white/40">{isZh ? it.descZh : it.descEn}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
